/* global G */
import ui from 'lib/hook/ui/update'
import onlineCheck from 'app/_shared/hook/onlineCheck'
import platform from 'app/_shared/hook/platform'
import multiCreate from 'app/_shared/hook/appbar/multiCreate'

const _listHooks = {
  before: [
    onlineCheck(),
    platform({
      mobile: [multiCreate],
    }),
  ],
  after: [
    ui,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    contacts: _listHooks,
  },
}

export default hooks
